import { Attribute } from "../../common/generic/generic-explore-indicators";
import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import { Format } from "../../common/utils/format";

import {
  IAggregateRow,
  IGenericAggregateResponse,
} from "../../common/generic/generic-types";
type DataArrayType = Array<string | number | null>;
export let SymbolText = "";
export function GetResponseinJson(
  responseData: IGenericAggregateResponse
): Array<{ [index: string]: string | number }> {
  let obj: { [index: string]: string | number } = {};
  const topValues: Array<{ [index: string]: string | number }> = [];
  for (const item of responseData.aggregates ? responseData.aggregates : []) {
    if (item.dimensionAttributeValues !== undefined) {
      obj = item.dimensionAttributeValues;
      for (const kpiKey of Object.keys(item.indicatorKpiValues)) {
        obj[kpiKey] = item.indicatorKpiValues[kpiKey];
      }
      topValues.push(obj);
    }
  }
  return topValues;
}

export function GetResponseinCsv(
  responseData: IGenericAggregateResponse
): DataArrayType[] {
  const aggr = new Array<DataArrayType>();
  const allAttributes: Attribute[] = getAllAttributes();
  let i = 0;
  const million = 1000000;
  const symbol: string[] = [];
  let kpiIndex = 0;
  (responseData.aggregates as IAggregateRow[]).forEach(responseAggr => {
    aggr.push(new Array<string | number | null>());
    allAttributes.forEach(staticAttr => {
      if (responseAggr.dimensionAttributeValues[staticAttr.id] === null) {
        aggr[i].push(null);
      } else {
        aggr[i].push(
          responseAggr.dimensionAttributeValues[staticAttr.id] === "Null"
            ? "--"
            : responseAggr.dimensionAttributeValues[staticAttr.id]
        );
      }
    });
    for (const kpiKey of Object.keys(responseAggr.indicatorKpiValues)) {
      kpiIndex = aggr[i].length;
      responseAggr.indicatorKpiValues[kpiKey] > million
        ? symbol.push("M")
        : symbol.push("K");
      aggr[i].push(responseAggr.indicatorKpiValues[kpiKey]);
    }
    i++;
  });
  if (responseData.request && symbol.length > 0) {
    AssignSymbolText(aggr, kpiIndex, symbol, responseData.request.kpis);
  }
  return aggr;
}

export function getAllKpis() {
  return [
    {
      bucketable: false,
      dataType: "",
      description: "",
      id: "sc_cva_fee",
      name: "CVA Fee",
      old_name: "CVA Fee (K€)",
    },
    {
      bucketable: false,
      dataType: "",
      description: "",
      id: "sc_f2y",
      name: "F(Y)",
      old_name: "F(Y) (K€)",
    },
    {
      bucketable: false,
      dataType: "",
      description: "",
      id: "sc_markup",
      name: "Markup",
      old_name: "Markup (K€)",
    },
    {
      bucketable: false,
      dataType: "",
      description: "",
      id: "sc_markup_ytd",
      name: "YTD Mark Up",
      old_name: "YTD Mark Up",
    },
    {
      bucketable: false,
      dataType: "",
      description: "",
      id: "marksc_nominal",
      name: "Nominal",
      old_name: "Nominal (K€)",
    },
    {
      bucketable: false,
      dataType: "",
      description: "",
      id: "sc_sc",
      name: "SC",
      old_name: "SC (K€)",
    },
    {
      bucketable: false,
      dataType: "",
      description: "",
      id: "sc_usd",
      name: "SC (USD)",
      old_name: "SC (KUSD)",
    },
  ];
}

// tslint:disable-next-line:no-big-function
export function getAllAttributes() {
  return [
    {
      description: "Business Level 1",
      example: "",
      id: SCAttributes.SC_FPV_BUSINESS_L1,
      name: "Business Level 1",
    },
    {
      description: "Business Level 2",
      example: "",
      id: SCAttributes.SC_FPV_BUSINESS_L2,
      name: "Business Level 2",
    },
    {
      description: "Business Level 3",
      example: "",
      id: SCAttributes.SC_FPV_BUSINESS_L3,
      name: "Business Level 3",
    },
    {
      description: "Business Type",
      example: "",
      id: SCAttributes.SC_MARK_BUSTYPE,
      name: "Business Type",
    },
    {
      description: "Client Typology Level 2",
      example: "",
      id: SCAttributes.SC_CLIENT_LE_TYPEL2_NAME,
      name: "Client Typology Level 2",
    },
    {
      description: "Client Typology Level 3",
      example: "",
      id: SCAttributes.SC_CLIENT_LE_TYPEL3_NAME,
      name: "Client Typology Level 3",
    },
    {
      description: "Final Client-Comm Country LE",
      example: "",
      id: SCAttributes.SC_CLIENT_LE_CTRY_NAME,
      name: "Final Client-Comm Country LE",
    },
    {
      description: "Final Comm Group",
      example: "",
      id: SCAttributes.SC_CLIENT_GROUPNAME,
      name: "Final Comm Group",
    },
    {
      description: "Final Comm Legal Entity",
      example: "",
      id: SCAttributes.SC_CLIENT_LENAME,
      name: "Final Comm Legal Entity",
    },
    {
      description: "Final EC Legal Entity",
      example: "",
      id: SCAttributes.SC_CLIENT_EC_FULLNAME,
      name: "Final EC Legal Entity",
    },
    {
      description: "Is Elec",
      example: "",
      id: SCAttributes.SC_MARK_IS_ELEC,
      name: "Is Elec",
    },
    {
      description: "Mandate Country",
      example: "",
      id: SCAttributes.SC_MANDATE_COUNTRY,
      name: "Mandate Country",
    },
    {
      description: "Mandate Region",
      example: "",
      id: SCAttributes.SC_MANDATE_REGION,
      name: "Mandate Region",
    },
    {
      description: "Mandate Zone",
      example: "",
      id: SCAttributes.SC_MANDATE_ZONE,
      name: "Mandate Zone",
    },
    {
      description: "Primary Secondary",
      example: "",
      id: SCAttributes.SC_MARKDEALS_PRIMARY_SECONDARY,
      name: "Primary Secondary",
    },
    {
      description: "Product Level 1",
      example: "",
      id: SCAttributes.SC_PRODUCT_LEVEL1,
      name: "Product Level 1",
    },
    {
      description: "Product Level 2",
      example: "",
      id: SCAttributes.SC_PRODUCT_LEVEL2,
      name: "Product Level 2",
    },
    {
      description: "Product Level 3",
      example: "",
      id: SCAttributes.SC_PRODUCT_LEVEL3,
      name: "Product Level 3",
    },
    {
      description: "Product Level 4",
      example: "",
      id: SCAttributes.SC_PRODUCT_LEVEL4,
      name: "Product Level 4",
    },
    {
      description: "Product Name",
      example: "",
      id: SCAttributes.SC_MARKDEALS_PRODUCT_NAME,
      name: "Product Name",
    },
    {
      description: "Profit Center",
      example: "",
      id: SCAttributes.SC_FPV_PCMNEMO,
      name: "Profit Center",
    },
    {
      description: "Sales Credit Ticker",
      example: "",
      id: SCAttributes.SC_TICKER,
      name: "Sales Credit Ticker",
    },
    {
      description: "Sales Operating Group",
      example: "",
      id: SCAttributes.SC_FPV_GOP,
      name: "Sales Operating Group",
    },
    {
      description: "Sales Name",
      example: "",
      id: SCAttributes.SC_SALESBEN_SALES,
      name: "Sales Name",
    },
    {
      description: "Sales Team",
      example: "",
      id: SCAttributes.SC_SALESBEN_TEAM,
      name: "Sales Team",
    },
    {
      description: "Sales Team Desc",
      example: "",
      id: SCAttributes.SC_SALESBEN_TEAM_LNAME,
      name: "Sales Team Desc",
    },
    {
      description: "Sub Business Unit",
      example: "",
      id: SCAttributes.SC_FPV_SBUMNEMO,
      name: "Sub Business Unit",
    },
    {
      description: "Sub Deal Type",
      example: "",
      id: SCAttributes.SC_MARKDEALS_SUB_DEAL_TYPE_NAME,
      name: "Sub Deal Type",
    },
    {
      description: "Trader PC Label",
      example: "",
      id: SCAttributes.SC_FPV_TRADE_LABEL,
      name: "Trader PC Label",
    },
    {
      description: "Trader Profit Center",
      example: "",
      id: SCAttributes.SC_FPV_TRADE_PC,
      name: "Trader Profit Center",
    },
    {
      description: "Underlying Name",
      example: "",
      id: SCAttributes.SC_MARKDEALS_UNDERLYING_CODE,
      name: "Underlying Name",
    },
    {
      description: "Year",
      example: "",
      id: SCAttributes.SC_CALENDAR_YEAR,
      name: "Year",
    },
    {
      description: "Quarter",
      example: "",
      id: "calendar_quarter_label",
      name: "Quarter",
    },
    {
      description: "Month",
      example: "",
      id: "calendar_month_label",
      name: "Month",
    },
    {
      description: "Week",
      example: "",
      id: SCAttributes.SC_CALENDAR_WEEK,
      name: "Week",
    },
    {
      description: "Day",
      example: "",
      id: SCAttributes.SC_CALENDAR_DATE,
      name: "Day",
    },
    {
      description: "Source Application",
      example: "",
      id: SCAttributes.SC_SOURCE_APP_MNEMO,
      name: "Source Application",
    },
    {
      description: "Way",
      example: "",
      id: SCAttributes.SC_MARKDEALS_WAY,
      name: "Way",
    },
    {
      description: "Originating Region",
      example: "",
      id: SCAttributes.SC_OE_RES_REG_CODE,
      name: "Originating Region",
    },
    {
      description: "Sales Region",
      example: "",
      id: SCAttributes.SC_FPV_SALES_REGION,
      name: "Sales Region",
    },
    {
      description: "Sales Zone",
      example: "",
      id: SCAttributes.SC_FPV_SALES_ZONE,
      name: "Sales Zone",
    },
    {
      description: "Sales Country",
      example: "",
      id: SCAttributes.SC_FPV_SALES_COUNTRY,
      name: "Sales Country",
    },
    {
      description: "Client - LE - Typology Level 1",
      example: "",
      id: SCAttributes.SC_CLIENT_LE_TYPO_L1,
      name: "Client - LE - Typology Level 1",
    },
    {
      description: "Client - LE - Region Name",
      example: "",
      id: SCAttributes.SC_CLIENT_LE_REG_NAME,
      name: "Client - LE - Region Name",
    },
    {
      description: "Client - LE - Sub Region Name",
      example: "",
      id: SCAttributes.SC_CLIENT_LE_SUBREG_NAME,
      name: "Client - LE - Sub Region Name",
    },
    {
      description: "Client - LE - Country Grouping Name",
      example: "",
      id: SCAttributes.SC_CLIENT_LE_CTRY_GRP_NAME,
      name: "Client - LE - Country Grouping Name",
    },
    {
      description: "Client - LE - PCRU",
      example: "",
      id: SCAttributes.SC_FINAL_CLIENT_FOLOWUP_CLASS_NAME,
      name: "Client - LE - PCRU",
    },
    {
      description: "Client - EC - Cambist Name",
      example: "",
      id: SCAttributes.SC_FINAL_CLIENT_CAMBIST_NAME,
      name: "Client - EC - Cambist Name",
    },
    {
      description: "Trader Sub Business Unit Mnemo",
      example: "",
      id: SCAttributes.SC_FPV_TRADE_SUBMNEMO,
      name: "Trader Sub Business Unit Mnemo",
    },
    {
      description: "Product Category Name",
      example: "",
      id: SCAttributes.SC_PRODUCT_CATEGORY_NAME,
      name: "Product Category Name",
    },
    {
      description: "Product Family Name",
      example: "",
      id: SCAttributes.SC_MARKDEALS_PRODUCT_FAMILY_NAME,
      name: "Product Family Name",
    },
    {
      description: "Equity/fixed Income Deals",
      example: "",
      id: SCAttributes.SC_MARKDEALS_EQYFI,
      name: "Equity/fixed Income Deals",
    },
    {
      description: "Nominal Currency",
      example: "",
      id: SCAttributes.SC_MARK_NOMINAL_CURRENCY,
      name: "Nominal Currency",
    },
    {
      description: "Negotiated Currency",
      example: "",
      id: SCAttributes.SC_MARK_NEGOTIATED_CURRENCY,
      name: "Negotiated Currency",
    },
    {
      description: "Product - Spark - Id Montage",
      example: "",
      id: SCAttributes.SC_SPARK_IDMONTAGE,
      name: "Product - Spark - Id Montage",
    },
    {
      description: "Agency DR Name",
      example: "",
      id: SCAttributes.SC_AGENCY_DR_NAME,
      name: "Agency DR Name",
    },
    {
      description: "Deal Currency",
      example: "",
      id: SCAttributes.SC_CLI_MARK_CURRENCY,
      name: "Deal Currency",
    },
    {
      description: "Deal Currency EM/G10",
      example: "",
      id: SCAttributes.SC_CLI_MARK_CURRENCY_EMG10,
      name: "Deal Currency EM/G10",
    },
    {
      description: "Deal Currency Zones",
      example: "",
      id: SCAttributes.SC_CLI_MARK_CURRENCY_ZONES,
      name: "Deal Currency Zones",
    },
    {
      description: "Sales - sub business unit",
      example: "",
      id: SCAttributes.SC_FPV_SBUMNEMO,
      name: "Sales - sub business unit",
    },
    {
      description: "FPV Trd - Inv. Sol./Flow/Fin.",
      example: "",
      id: SCAttributes.SC_FPV_TRADE_INVFLOWFIN,
      name: "FPV Trd - Inv. Sol./Flow/Fin.",
    },
    {
      description: "Team Activity Label",
      example: "",
      id: SCAttributes.SC_TEAM_ACTIVITY,
      name: "Team Activity Label",
    },
    {
      description: "Team Desk Label",
      example: "",
      id: SCAttributes.SC_TEAM_DESK,
      name: "Team Desk Label",
    },
  ];
}

function AssignSymbolText(
  aggr: DataArrayType[],
  kpiIndex: number,
  symbol: string[],
  kpi?: string
) {
  for (const item of aggr) {
    if (item !== null && symbol.length > 0) {
      SymbolText = kpi === "sc_usd" ? "KUSD" : "K€";
      item[kpiIndex] = Format.FormatNumberByLabel(
        item[kpiIndex] as number,
        "k",
        2
      );
    }
  }
}
